module.exports = __webpack_public_path__ + "img/hero-bg-tab.6a0b40f.webp";